import { DatePipe, UpperCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigManagerModule, CONFIG_MANAGER_SERVICE_CONFIGURATION } from '@xpo-ltl/config-manager';
import { DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { SdkEquipmentModule } from '@xpo-ltl/sdk-equipment';
import { SdkHumanResourceModule } from '@xpo-ltl/sdk-humanresource';
import { SdkLinehaulPayformModule } from '@xpo-ltl/sdk-linehaulpayform';
import { SdkLocationModule } from '@xpo-ltl/sdk-location';
import { LoggingApiService, SdkLoggingModule } from '@xpo-ltl/sdk-logging';
import { PayrollApiService } from '@xpo-ltl/sdk-payroll';
import { SdkReferenceModule } from '@xpo-ltl/sdk-reference';
import { AppDialogsModule } from './app-dialogs.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { ListPayformsComponent } from './components/list-payforms/list-payforms.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { NotificationComponent } from './components/notification/notification.component';
import { ErrorWarningService, PayFormService } from './components/payform/services';
import { PayformsFilterChipsComponent } from './components/payforms-filter-chips/payforms-filter-chips.component';
import { DialogsModule } from './dialogs/dialogs.module';
import { MaterialModule } from './material.module';
import { XpoPipesModule } from './pipes/xpo-pipes.module';
import { PayformResolver } from './resolvers/payform.resolver';
import { EquipmentDetailsCacheService, LocationDetailsCacheService, RoutingInstructionsCacheService, ServiceCenterCacheService } from './services';
import { AppConstantsService } from './services/app-constants.service';
import { AppFooterService } from './services/app-footer/app-footer.service';
import { AsyncValidatorCompletionService } from './services/async-validator-completion.service';
import { DriverPayService } from './services/driver-pay/driver-pay.service';
import { ScrollbarService } from './services/scrollbar/scrollbar.service';
import { UtilsModule } from './utils/utils.module';
import { ValidatorsModule } from './validators/validators.module';
import { NgIdleModule } from '@ng-idle/core';
import { IdleTimeoutService } from './services/idle-timeout.service';
import { AppHeaderService } from './services/app-header/app-header.service';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ROOT_REDUCERS } from './state/app.state';
import { LoginModule } from './login/login.module';
import { XpoDirectivesModule } from './utils/angular-utils/directives';
import { EmailService } from './utils/angular-utils/services';
import { XpoValidatorsModule } from './utils/angular-utils/validators/xpo-validators.module';
import { XpoAngularUtilsModule } from './utils/angular-utils/xpo-angular-utils.module';

@NgModule({
  declarations: [AppComponent, AppFooterComponent, AppHeaderComponent, ListPayformsComponent, NotAuthorizedComponent, NotificationComponent, PayformsFilterChipsComponent],
  imports: [
    AppDialogsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ConfigManagerModule,
    DialogsModule,
    LoginModule,
    MatDatepickerModule,
    MaterialModule,
    SdkEquipmentModule,
    SdkHumanResourceModule,
    SdkLinehaulPayformModule,
    SdkLocationModule,
    SdkLoggingModule,
    SdkReferenceModule,
    UtilsModule,
    ValidatorsModule,
    XpoAngularUtilsModule,
    XpoDirectivesModule,
    XpoPipesModule,
    XpoValidatorsModule,
    NgIdleModule.forRoot(),
    StoreModule.forRoot(ROOT_REDUCERS),
    StoreDevtoolsModule.instrument({ name: 'TEST' }),
  ],
  providers: [
    {
      provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
      useValue: { configFileUrl: './assets/config.json' },
    },
    AppConstantsService,
    AppHeaderService,
    AppFooterService,
    AsyncValidatorCompletionService,
    DataApiService,
    DatePipe,
    DriverPayService,
    EquipmentDetailsCacheService,
    LocationDetailsCacheService,
    LoggingApiService,
    NotificationService,
    PayformResolver,
    PayFormService,
    ErrorWarningService,
    PayrollApiService,
    RoutingInstructionsCacheService,
    ScrollbarService,
    ServiceCenterCacheService,
    UpperCasePipe,
    EmailService,
    IdleTimeoutService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
